// `color`/`bg` style chips; `marker` is a brighter variant that stays legible
// as a map circle on the dark map style (see src/utils/markers.js).
export const PROGRAM_META = {
  krisplus: {
    label: 'Kris+ 8MPD',
    short: 'Kris+',
    color: '#1565c0',
    bg: 'rgba(21,101,192,0.18)',
    marker: '#42a5f5',
  },
  entertainer: {
    label: 'Entertainer',
    short: 'ENT',
    color: '#e65100',
    bg: 'rgba(230,81,0,0.18)',
    marker: '#ff9800',
  },
  burrple: {
    label: 'Burrple Beyond',
    short: 'Burrple',
    color: '#6a1b9a',
    bg: 'rgba(106,27,154,0.18)',
    marker: '#ab47bc',
  },
};

export const ALL_PROGRAMS = ['krisplus', 'entertainer', 'burrple'];
